// 导入自己需要的组件
import { Dialog,Button } from 'element-ui'
const element = {
    install: function (Vue) {
        Vue.use(Dialog)
        Vue.use(Button)
    }
}
export default element
